/* Replace only the authoritative cart body; never synthesize prices or offers. */
(() => {
  'use strict';
  const create = (page) => {
    const document = page.ownerDocument;
    const context = { sectionId: page.dataset.cartPageSection, country: page.dataset.cartPageCountry, currency: page.dataset.cartPageCurrency };
    const body = () => page.querySelector('[data-cart-page-body]');
    const feedback = page.querySelector('[data-cart-page-feedback]');
    const message = page.querySelector('[data-cart-page-message]');
    const refresh = page.querySelector('[data-cart-page-reconcile]');
    if (!body() || !feedback || !message || !refresh) throw new Error('Missing cart page markup');
    const notify = (text = '', canRefresh = false) => {
      message.textContent = text;
      feedback.hidden = !text;
      refresh.hidden = !canRefresh;
    };
    const state = ({ busy, blocked }) => {
      page.setAttribute('aria-busy', String(busy));
      body().inert = busy || blocked;
      refresh.disabled = busy;
    };
    const apply = ({ cart, html }) => {
      if (typeof html !== 'string' || !html.trim()) throw new Error('Cart section unavailable');
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const pages = parsed.querySelectorAll('[data-cart-page]');
      if (pages.length !== 1) throw new Error('Invalid cart section');
      const incoming = pages[0];
      if (incoming.dataset.cartPageSection !== context.sectionId || incoming.dataset.cartPageCountry !== context.country || incoming.dataset.cartPageCurrency !== context.currency || cart.currency !== context.currency) throw new Error('Cart context changed');
      const bodies = incoming.querySelectorAll('[data-cart-page-body]');
      if (bodies.length !== 1 || bodies[0].dataset.cartPageTotalMinor !== String(cart.total_price)) throw new Error('Cart totals changed during refresh');
      const items = window.PFCartPageAPI.visibleItems(cart);
      const rows = [...bodies[0].querySelectorAll('[data-cart-page-line]')];
      if (rows.length !== items.length || rows.some((row, index) => row.dataset.cartPageLine !== items[index].key || Number(row.querySelector('[data-cart-page-quantity]')?.value) !== items[index].quantity)) throw new Error('Cart lines changed during refresh');
      const active = document.activeElement;
      const focusedRow = body().contains(active) ? active.closest?.('[data-cart-page-line]') : null;
      const focusedKey = focusedRow?.dataset.cartPageLine;
      const fresh = document.importNode(bodies[0], true);
      body().replaceWith(fresh);
      const count = items.reduce((sum, item) => sum + item.quantity, 0);
      document.querySelectorAll('.cart-count').forEach((badge) => { badge.textContent = count; badge.hidden = count === 0; });
      // Do not steal focus from a country selector or another independent form.
      if (focusedKey && (document.activeElement === active || document.activeElement === document.body)) {
        const sameRow = [...fresh.querySelectorAll('[data-cart-page-line]')].find((row) => row.dataset.cartPageLine === focusedKey);
        const focus = sameRow?.querySelector('[data-cart-page-quantity]') || fresh.querySelector('h1');
        if (focus) { if (focus.tagName === 'H1') focus.tabIndex = -1; focus.focus({ preventScroll: true }); }
      }
    };
    return Object.freeze({ apply, notify, state });
  };
  window.PFCartPageView = Object.freeze({ create });
})();
